var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.037 4.841a.625.625 0 0 1 .884 0l4.709 4.717a.625.625 0 0 1 0 .883L8.92 15.159a.625.625 0 1 1-.884-.883L12.304 10 8.037 5.725a.625.625 0 0 1 0-.884Z",
  fill: "#8B97A7"
})));
export default SvgIcChevronRight;